// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Custom Properties - Fleetly Theme System */
:root {
  /* 🎨 Primary Colors (Brand Foundation)
   * These navies anchor your brand and provide a strong, professional base.
   * Use for: Headers, primary buttons, main navigation, brand elements
   */
  --fleetly-primary-navy: #1B3A57;
  --fleetly-primary-navy-dark: #15304A;
  
  /* 🟢 Secondary Colors (Supportive Brand Elements)
   * Teal adds freshness and balance, ideal for calming or informative UI components.
   * Use for: Course-related actions, secondary buttons, success states, info panels
   */
  --fleetly-secondary-teal: #4ECDC4;
  --fleetly-secondary-teal-dark: #42C2BB;
  
  /* 🔵 Accent Blues (Highlights & Interactions)
   * These blues guide attention and reinforce interactivity.
   * Use for: Links, active states, save buttons, primary actions, selected items
   */
  --fleetly-accent-blue: #45B7D1;
  --fleetly-accent-blue-dark: #3A9BC1;
  
  /* 🟠 Accent Oranges (Alerts & Energy)
   * Orange injects urgency and warmth—great for drawing attention.
   * Use for: CTAs, warnings, highlights, edit actions, moderate alerts
   */
  --fleetly-accent-orange: #F96332;
  --fleetly-accent-orange-dark: #F7521A;
  
  /* 🟣 Accent Purple (Creative & Premium Touches)
   * Purple adds sophistication and is perfect for moments of delight or creativity.
   * Use for: Special features, premium actions, creative tools, unique elements
   */
  --fleetly-accent-purple: #7B3F8C;
  
  /* 🔴 Accent Reds (Errors & Critical Actions)
   * Red signals danger or urgency—use sparingly for impact.
   * Use for: Errors, delete actions, critical warnings, emergency stops
   */
  --fleetly-accent-red: #E94B3C;
  --fleetly-accent-red-dark: #C13B2A;
  
  /* 🟡 Accent Yellows (Caution & Highlights)
   * Yellow is great for drawing attention without alarm.
   * Use for: Warnings, highlights, pending states, important info
   */
  --fleetly-accent-yellow: #F7C948;
  --fleetly-accent-yellow-dark: #D9A527;
  
  /* 🤎 Browns - Earth tones, natural elements */
  --fleetly-brown-light: #D4B5A0;    /* Light brown for backgrounds */
  --fleetly-brown-medium: #A0825C;   /* Medium brown for borders */
  --fleetly-brown-dark: #6B4423;     /* Dark brown for text on light backgrounds */

  /* ✅ Success & Status Colors - Enhanced button hierarchy */
  --fleetly-success-light: #E8F5E8;  /* Success background states */
  --fleetly-success-medium: #4CAF50; /* Success buttons, confirmations */
  --fleetly-success-dark: #2E7D32;   /* Success button hover states */

  /* ⚫ Disabled & Muted States - Button hierarchy support */
  --fleetly-disabled-light: #F5F5F5; /* Disabled button backgrounds */
  --fleetly-disabled-medium: #BDBDBD; /* Disabled borders and icons */
  --fleetly-disabled-dark: #757575;  /* Disabled text */
  --fleetly-muted-light: #FAFAFA;    /* Muted backgrounds for secondary actions */
  --fleetly-muted-medium: #E0E0E0;   /* Muted borders */
  --fleetly-muted-dark: #9E9E9E;     /* Muted text for tertiary actions */

  /* Usage Guide:
   * Primary Navy: Main brand color, primary buttons, headers
   * Secondary Teal: Secondary actions, highlights, accents
   * Accent Blue: Information, links, secondary buttons
   * Accent Orange: Warning states, PIN buttons, alerts
   * Accent Purple: Special features, premium content
   * Success Green: Success states, confirmation buttons, positive actions
   * Red variants: Error states, danger buttons, alerts
   * Yellow variants: Warning backgrounds, caution states
   * Neutral variants: Text, borders, backgrounds, disabled states
   * Brown variants: Earth tones, natural sailing elements
   * Success variants: Confirmations, completed states, positive feedback
   * Disabled/Muted variants: Inactive buttons, secondary/tertiary actions
   */
  
  /* ⚪️ Neutrals (Structure & Readability)
   * Neutrals ensure clarity and contrast, supporting all other colors.
   * Use for: Text, borders, backgrounds, disabled states, subtle elements
   */
  --fleetly-neutral-light: #F4F4F4;
  --fleetly-neutral-dark: #2E2E2E;

  /* Light Theme (Default) */
  --fleetly-background: #F8F9FA;
  --fleetly-surface: #FFFFFF;
  --fleetly-text: #1B3A57;
  --fleetly-text-subtle: #6C757D;
  --fleetly-border: #E9ECEF;

  /* Navigation */
  --fleetly-nav-background: #FFFFFF;
  --fleetly-nav-text: #1B3A57;
  --fleetly-nav-active: #F96332;

  /* Buttons */
  --fleetly-btn-bg: #E9ECEF;
  --fleetly-btn-text: #1B3A57;
  --fleetly-btn-bg-primary: #1B3A57;
  --fleetly-btn-text-primary: #FFFFFF;

  /* Component specific */
  --fleetly-value-text: #1B3A57;
  --fleetly-label-text: #6C757D;
}

/* Dark Theme Override */
.theme-dark {
  --fleetly-background: #0F1419;
  --fleetly-surface: #1B2832;
  --fleetly-text: #FFFFFF;
  --fleetly-text-subtle: #B8C5D1;
  --fleetly-border: #3A4B56;
  --fleetly-nav-background: #1B2832;
  --fleetly-nav-text: #FFFFFF;
  --fleetly-nav-active: #FF7A4D;
  --fleetly-btn-bg: #253138;
  --fleetly-btn-text: #FFFFFF;
  --fleetly-accent-purple-dark: #9B5FAE;
}

/* Forest Theme Override */
.theme-forest {
  --fleetly-background: #283618;
  --fleetly-surface: #3A4B2A;
  --fleetly-text: #FEFAE0;
  --fleetly-text-subtle: #FEFAE0;
  --fleetly-border: #606C38;
  --fleetly-nav-background: #3A4B2A;
  --fleetly-nav-text: #FEFAE0;
  --fleetly-nav-active: #BC6C25;
  --fleetly-btn-bg: #DDA15E;
  --fleetly-btn-text: #FEFAE0;
  --fleetly-accent-purple-forest: #8B6FA3;
}

/* Reset styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  width: 100%;
  height: 100%;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: var(--fleetly-text);
  background-color: var(--fleetly-background);
  overflow-x: hidden;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
}

img {
  max-width: 100%;
  height: auto;
  display: block;
}

a {
  text-decoration: none;
  color: inherit;
}

button {
  font-family: inherit;
  font-size: inherit;
  cursor: pointer;
  border: none;
  background: none;
}

ul, ol {
  list-style: none;
}

/* Root container */
#root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* Utility classes for layout */
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.flex {
  display: flex;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.grid {
  display: grid;
  gap: 1rem;
}

/* Typography with Fleetly Theme */
h1, h2, h3, h4, h5, h6 {
  font-weight: 600;
  line-height: 1.2;
  color: var(--fleetly-text);
}

p {
  margin-bottom: 1rem;
  color: var(--fleetly-text);
}

small {
  font-size: 0.875rem;
  color: var(--fleetly-text-subtle);
}

/* Spacing */
.mt-1 { margin-top: 0.25rem; }
.mt-2 { margin-top: 0.5rem; }
.mt-3 { margin-top: 1rem; }

.mb-1 { margin-bottom: 0.25rem; }
.mb-2 { margin-bottom: 0.5rem; }
.mb-3 { margin-bottom: 1rem; }

/* Theme-aware Colors */
.text-primary { color: var(--fleetly-accent-blue); }
.text-danger { color: var(--fleetly-accent-orange); }
.text-muted { color: var(--fleetly-text-subtle); }
.text-navy { color: var(--fleetly-primary-navy); }
.text-teal { color: var(--fleetly-secondary-teal); }

.bg-primary { background-color: var(--fleetly-accent-blue); color: var(--fleetly-surface); }
.bg-danger { background-color: var(--fleetly-accent-orange); color: var(--fleetly-surface); }
.bg-navy { background-color: var(--fleetly-primary-navy); color: var(--fleetly-surface); }
.bg-surface { background-color: var(--fleetly-surface); color: var(--fleetly-text); }

/* Visibility */
.hidden { display: none; }

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #999;
}

/* Transitions */
button, a {
  transition: all 0.2s ease-in-out;
}

/* Theme-aware form element styling */
input, textarea, select {
  font-family: inherit;
  font-size: 1rem;
  padding: 0.5rem;
  border: 1px solid var(--fleetly-border);
  border-radius: 4px;
  width: 100%;
  background-color: var(--fleetly-surface);
  color: var(--fleetly-text);
  transition: border-color 0.2s ease-in-out;
}

input:focus, textarea:focus, select:focus {
  outline: none;
  border-color: var(--fleetly-accent-blue);
  box-shadow: 0 0 0 2px rgba(69, 183, 209, 0.2);
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--fleetly-text);
}

/* Responsive typography */
@media (max-width: 768px) {
  html {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  h1 { font-size: 1.8rem; }
  h2 { font-size: 1.5rem; }
  h3 { font-size: 1.3rem; }
}

/* Print styles */
@media print {
  body {
    background-color: white;
    color: black;
  }
  
  .no-print {
    display: none;
  }
}

/* Extend spacing utilities */
.p-1 { padding: 0.25rem; }
.p-2 { padding: 0.5rem; }
.p-3 { padding: 1rem; }

.mx-auto { margin-left: auto; margin-right: auto; }

/* Focus styles for accessibility with Fleetly colors */
:focus-visible {
  outline: 2px solid var(--fleetly-accent-blue);
  outline-offset: 2px;
}

/* Skip to main content link for keyboard users */
.skip-link {
  position: absolute;
  left: -9999px;
  top: 0;
  padding: 0.5rem 1rem;
  background-color: var(--fleetly-accent-blue);
  color: white;
  z-index: 9999;
}

.skip-link:focus {
  left: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/globals.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE;;;IAGE;EACF,+BAA+B;EAC/B,oCAAoC;;EAEpC;;;IAGE;EACF,iCAAiC;EACjC,sCAAsC;;EAEtC;;;IAGE;EACF,8BAA8B;EAC9B,mCAAmC;;EAEnC;;;IAGE;EACF,gCAAgC;EAChC,qCAAqC;;EAErC;;;IAGE;EACF,gCAAgC;;EAEhC;;;IAGE;EACF,6BAA6B;EAC7B,kCAAkC;;EAElC;;;IAGE;EACF,gCAAgC;EAChC,qCAAqC;;EAErC,8CAA8C;EAC9C,8BAA8B,KAAK,gCAAgC;EACnE,+BAA+B,IAAI,6BAA6B;EAChE,6BAA6B,MAAM,6CAA6C;;EAEhF,0DAA0D;EAC1D,gCAAgC,GAAG,8BAA8B;EACjE,iCAAiC,EAAE,mCAAmC;EACtE,+BAA+B,IAAI,gCAAgC;;EAEnE,yDAAyD;EACzD,iCAAiC,EAAE,gCAAgC;EACnE,kCAAkC,EAAE,+BAA+B;EACnE,gCAAgC,GAAG,kBAAkB;EACrD,8BAA8B,KAAK,4CAA4C;EAC/E,+BAA+B,IAAI,kBAAkB;EACrD,6BAA6B,MAAM,oCAAoC;;EAEvE;;;;;;;;;;;;;IAaE;;EAEF;;;IAGE;EACF,gCAAgC;EAChC,+BAA+B;;EAE/B,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;;EAEzB,eAAe;EACf,iCAAiC;EACjC,2BAA2B;EAC3B,6BAA6B;;EAE7B,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;EAC3B,iCAAiC;EACjC,mCAAmC;;EAEnC,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,iCAAiC;EACjC,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA,0BAA0B;AAC1B;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,iCAAiC;EACjC,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA,iBAAiB;AACjB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wIAAwI;EACxI,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,2CAA2C;EAC3C,kBAAkB;EAClB,qEAAqE;AACvE;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA,YAAY;AACZ,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,gBAAgB,EAAE;;AAE1B,QAAQ,sBAAsB,EAAE;AAChC,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,mBAAmB,EAAE;;AAE7B,uBAAuB;AACvB,gBAAgB,iCAAiC,EAAE;AACnD,eAAe,mCAAmC,EAAE;AACpD,cAAc,iCAAiC,EAAE;AACjD,aAAa,kCAAkC,EAAE;AACjD,aAAa,oCAAoC,EAAE;;AAEnD,cAAc,4CAA4C,EAAE,6BAA6B,EAAE;AAC3F,aAAa,8CAA8C,EAAE,6BAA6B,EAAE;AAC5F,WAAW,6CAA6C,EAAE,6BAA6B,EAAE;AACzF,cAAc,wCAAwC,EAAE,0BAA0B,EAAE;;AAEpF,eAAe;AACf,UAAU,aAAa,EAAE;;AAEzB,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;AAClC;;AAEA,qCAAqC;AACrC;EACE,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,uCAAuC;EACvC,kBAAkB;EAClB,WAAW;EACX,wCAAwC;EACxC,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,KAAK,iBAAiB,EAAE;EACxB,KAAK,iBAAiB,EAAE;EACxB,KAAK,iBAAiB,EAAE;AAC1B;;AAEA,iBAAiB;AACjB;EACE;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,6BAA6B;AAC7B,OAAO,gBAAgB,EAAE;AACzB,OAAO,eAAe,EAAE;AACxB,OAAO,aAAa,EAAE;;AAEtB,WAAW,iBAAiB,EAAE,kBAAkB,EAAE;;AAElD,uDAAuD;AACvD;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,aAAa;EACb,MAAM;EACN,oBAAoB;EACpB,4CAA4C;EAC5C,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,OAAO;AACT","sourcesContent":["/* CSS Custom Properties - Fleetly Theme System */\n:root {\n  /* 🎨 Primary Colors (Brand Foundation)\n   * These navies anchor your brand and provide a strong, professional base.\n   * Use for: Headers, primary buttons, main navigation, brand elements\n   */\n  --fleetly-primary-navy: #1B3A57;\n  --fleetly-primary-navy-dark: #15304A;\n  \n  /* 🟢 Secondary Colors (Supportive Brand Elements)\n   * Teal adds freshness and balance, ideal for calming or informative UI components.\n   * Use for: Course-related actions, secondary buttons, success states, info panels\n   */\n  --fleetly-secondary-teal: #4ECDC4;\n  --fleetly-secondary-teal-dark: #42C2BB;\n  \n  /* 🔵 Accent Blues (Highlights & Interactions)\n   * These blues guide attention and reinforce interactivity.\n   * Use for: Links, active states, save buttons, primary actions, selected items\n   */\n  --fleetly-accent-blue: #45B7D1;\n  --fleetly-accent-blue-dark: #3A9BC1;\n  \n  /* 🟠 Accent Oranges (Alerts & Energy)\n   * Orange injects urgency and warmth—great for drawing attention.\n   * Use for: CTAs, warnings, highlights, edit actions, moderate alerts\n   */\n  --fleetly-accent-orange: #F96332;\n  --fleetly-accent-orange-dark: #F7521A;\n  \n  /* 🟣 Accent Purple (Creative & Premium Touches)\n   * Purple adds sophistication and is perfect for moments of delight or creativity.\n   * Use for: Special features, premium actions, creative tools, unique elements\n   */\n  --fleetly-accent-purple: #7B3F8C;\n  \n  /* 🔴 Accent Reds (Errors & Critical Actions)\n   * Red signals danger or urgency—use sparingly for impact.\n   * Use for: Errors, delete actions, critical warnings, emergency stops\n   */\n  --fleetly-accent-red: #E94B3C;\n  --fleetly-accent-red-dark: #C13B2A;\n  \n  /* 🟡 Accent Yellows (Caution & Highlights)\n   * Yellow is great for drawing attention without alarm.\n   * Use for: Warnings, highlights, pending states, important info\n   */\n  --fleetly-accent-yellow: #F7C948;\n  --fleetly-accent-yellow-dark: #D9A527;\n  \n  /* 🤎 Browns - Earth tones, natural elements */\n  --fleetly-brown-light: #D4B5A0;    /* Light brown for backgrounds */\n  --fleetly-brown-medium: #A0825C;   /* Medium brown for borders */\n  --fleetly-brown-dark: #6B4423;     /* Dark brown for text on light backgrounds */\n\n  /* ✅ Success & Status Colors - Enhanced button hierarchy */\n  --fleetly-success-light: #E8F5E8;  /* Success background states */\n  --fleetly-success-medium: #4CAF50; /* Success buttons, confirmations */\n  --fleetly-success-dark: #2E7D32;   /* Success button hover states */\n\n  /* ⚫ Disabled & Muted States - Button hierarchy support */\n  --fleetly-disabled-light: #F5F5F5; /* Disabled button backgrounds */\n  --fleetly-disabled-medium: #BDBDBD; /* Disabled borders and icons */\n  --fleetly-disabled-dark: #757575;  /* Disabled text */\n  --fleetly-muted-light: #FAFAFA;    /* Muted backgrounds for secondary actions */\n  --fleetly-muted-medium: #E0E0E0;   /* Muted borders */\n  --fleetly-muted-dark: #9E9E9E;     /* Muted text for tertiary actions */\n\n  /* Usage Guide:\n   * Primary Navy: Main brand color, primary buttons, headers\n   * Secondary Teal: Secondary actions, highlights, accents\n   * Accent Blue: Information, links, secondary buttons\n   * Accent Orange: Warning states, PIN buttons, alerts\n   * Accent Purple: Special features, premium content\n   * Success Green: Success states, confirmation buttons, positive actions\n   * Red variants: Error states, danger buttons, alerts\n   * Yellow variants: Warning backgrounds, caution states\n   * Neutral variants: Text, borders, backgrounds, disabled states\n   * Brown variants: Earth tones, natural sailing elements\n   * Success variants: Confirmations, completed states, positive feedback\n   * Disabled/Muted variants: Inactive buttons, secondary/tertiary actions\n   */\n  \n  /* ⚪️ Neutrals (Structure & Readability)\n   * Neutrals ensure clarity and contrast, supporting all other colors.\n   * Use for: Text, borders, backgrounds, disabled states, subtle elements\n   */\n  --fleetly-neutral-light: #F4F4F4;\n  --fleetly-neutral-dark: #2E2E2E;\n\n  /* Light Theme (Default) */\n  --fleetly-background: #F8F9FA;\n  --fleetly-surface: #FFFFFF;\n  --fleetly-text: #1B3A57;\n  --fleetly-text-subtle: #6C757D;\n  --fleetly-border: #E9ECEF;\n\n  /* Navigation */\n  --fleetly-nav-background: #FFFFFF;\n  --fleetly-nav-text: #1B3A57;\n  --fleetly-nav-active: #F96332;\n\n  /* Buttons */\n  --fleetly-btn-bg: #E9ECEF;\n  --fleetly-btn-text: #1B3A57;\n  --fleetly-btn-bg-primary: #1B3A57;\n  --fleetly-btn-text-primary: #FFFFFF;\n\n  /* Component specific */\n  --fleetly-value-text: #1B3A57;\n  --fleetly-label-text: #6C757D;\n}\n\n/* Dark Theme Override */\n.theme-dark {\n  --fleetly-background: #0F1419;\n  --fleetly-surface: #1B2832;\n  --fleetly-text: #FFFFFF;\n  --fleetly-text-subtle: #B8C5D1;\n  --fleetly-border: #3A4B56;\n  --fleetly-nav-background: #1B2832;\n  --fleetly-nav-text: #FFFFFF;\n  --fleetly-nav-active: #FF7A4D;\n  --fleetly-btn-bg: #253138;\n  --fleetly-btn-text: #FFFFFF;\n  --fleetly-accent-purple-dark: #9B5FAE;\n}\n\n/* Forest Theme Override */\n.theme-forest {\n  --fleetly-background: #283618;\n  --fleetly-surface: #3A4B2A;\n  --fleetly-text: #FEFAE0;\n  --fleetly-text-subtle: #FEFAE0;\n  --fleetly-border: #606C38;\n  --fleetly-nav-background: #3A4B2A;\n  --fleetly-nav-text: #FEFAE0;\n  --fleetly-nav-active: #BC6C25;\n  --fleetly-btn-bg: #DDA15E;\n  --fleetly-btn-text: #FEFAE0;\n  --fleetly-accent-purple-forest: #8B6FA3;\n}\n\n/* Reset styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml, body {\n  width: 100%;\n  height: 100%;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  font-size: 16px;\n  line-height: 1.5;\n  color: var(--fleetly-text);\n  background-color: var(--fleetly-background);\n  overflow-x: hidden;\n  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\nbutton {\n  font-family: inherit;\n  font-size: inherit;\n  cursor: pointer;\n  border: none;\n  background: none;\n}\n\nul, ol {\n  list-style: none;\n}\n\n/* Root container */\n#root {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n/* Utility classes for layout */\n.container {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 15px;\n}\n\n.flex {\n  display: flex;\n}\n\n.flex-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.grid {\n  display: grid;\n  gap: 1rem;\n}\n\n/* Typography with Fleetly Theme */\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 600;\n  line-height: 1.2;\n  color: var(--fleetly-text);\n}\n\np {\n  margin-bottom: 1rem;\n  color: var(--fleetly-text);\n}\n\nsmall {\n  font-size: 0.875rem;\n  color: var(--fleetly-text-subtle);\n}\n\n/* Spacing */\n.mt-1 { margin-top: 0.25rem; }\n.mt-2 { margin-top: 0.5rem; }\n.mt-3 { margin-top: 1rem; }\n\n.mb-1 { margin-bottom: 0.25rem; }\n.mb-2 { margin-bottom: 0.5rem; }\n.mb-3 { margin-bottom: 1rem; }\n\n/* Theme-aware Colors */\n.text-primary { color: var(--fleetly-accent-blue); }\n.text-danger { color: var(--fleetly-accent-orange); }\n.text-muted { color: var(--fleetly-text-subtle); }\n.text-navy { color: var(--fleetly-primary-navy); }\n.text-teal { color: var(--fleetly-secondary-teal); }\n\n.bg-primary { background-color: var(--fleetly-accent-blue); color: var(--fleetly-surface); }\n.bg-danger { background-color: var(--fleetly-accent-orange); color: var(--fleetly-surface); }\n.bg-navy { background-color: var(--fleetly-primary-navy); color: var(--fleetly-surface); }\n.bg-surface { background-color: var(--fleetly-surface); color: var(--fleetly-text); }\n\n/* Visibility */\n.hidden { display: none; }\n\n/* Scrollbar styling */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #ccc;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: #999;\n}\n\n/* Transitions */\nbutton, a {\n  transition: all 0.2s ease-in-out;\n}\n\n/* Theme-aware form element styling */\ninput, textarea, select {\n  font-family: inherit;\n  font-size: 1rem;\n  padding: 0.5rem;\n  border: 1px solid var(--fleetly-border);\n  border-radius: 4px;\n  width: 100%;\n  background-color: var(--fleetly-surface);\n  color: var(--fleetly-text);\n  transition: border-color 0.2s ease-in-out;\n}\n\ninput:focus, textarea:focus, select:focus {\n  outline: none;\n  border-color: var(--fleetly-accent-blue);\n  box-shadow: 0 0 0 2px rgba(69, 183, 209, 0.2);\n}\n\nlabel {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: var(--fleetly-text);\n}\n\n/* Responsive typography */\n@media (max-width: 768px) {\n  html {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  h1 { font-size: 1.8rem; }\n  h2 { font-size: 1.5rem; }\n  h3 { font-size: 1.3rem; }\n}\n\n/* Print styles */\n@media print {\n  body {\n    background-color: white;\n    color: black;\n  }\n  \n  .no-print {\n    display: none;\n  }\n}\n\n/* Extend spacing utilities */\n.p-1 { padding: 0.25rem; }\n.p-2 { padding: 0.5rem; }\n.p-3 { padding: 1rem; }\n\n.mx-auto { margin-left: auto; margin-right: auto; }\n\n/* Focus styles for accessibility with Fleetly colors */\n:focus-visible {\n  outline: 2px solid var(--fleetly-accent-blue);\n  outline-offset: 2px;\n}\n\n/* Skip to main content link for keyboard users */\n.skip-link {\n  position: absolute;\n  left: -9999px;\n  top: 0;\n  padding: 0.5rem 1rem;\n  background-color: var(--fleetly-accent-blue);\n  color: white;\n  z-index: 9999;\n}\n\n.skip-link:focus {\n  left: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
